export const URL_PARAM_OPEN_LOGIN_POPUP = "login";
export const URL_PARAM_ON_LOGIN_ACTION = "loginAction";

export const LOGIN_ACTION_COPY_WISHLIST = "copyWishlist";
export const LOGIN_ACTION_COPY_SHARED_WISHLIST = "copySharedWishlist";
export const LOGIN_ACTION_COPY_WISHLIST_ID = "wishlistId";

export const LOGIN_ACTION_REDIRECT = "redirect";
export const LOGIN_ACTION_REDIRECT_URL = "url";
